<mat-dialog-content>
  <ng-container #vc></ng-container>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
  <button class="eCase-dialog-negative-action-button"
          (click)="onNoClick()"
          mat-raised-button>{{'ecase.common.close'| translate }}
  </button>
</mat-dialog-actions>
